import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'yesNo',
    standalone: false
})
export class YesNoPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: boolean): string {
    return this.translateService.instant(value ? 'Yes' : 'No');
  }
}
